import { WorkflowKind } from '@augloop/interfaces';
import { buildArrayOfTypes } from '../utils';
export class SingleItemWorkflow {
    constructor(id, opts) {
        var _a, _b, _c, _d, _e;
        this.kind = WorkflowKind.SingleItem;
        this.isStateful = false;
        this.id = id;
        if (opts) {
            this.inputTypes = (_a = opts.inputTypes) !== null && _a !== void 0 ? _a : this.inputTypes;
            this.outputTypes = (_b = opts.outputTypes) !== null && _b !== void 0 ? _b : this.outputTypes;
            this.requestedContextTypesRules = (_c = opts.requestedContextTypesRules) !== null && _c !== void 0 ? _c : this.requestedContextTypesRules;
            this.definitionOverrideTargetWorkflows = (_d = opts.definitionOverrideTargetWorkflows) !== null && _d !== void 0 ? _d : this.definitionOverrideTargetWorkflows;
            this.correlatedSignals = ((_e = opts.correlatedSignals) === null || _e === void 0 ? void 0 : _e.length) !== 0 ? opts.correlatedSignals : this.correlatedSignals;
        }
    }
    static create(id) {
        return new SingleItemWorkflow(id);
    }
    setInputTypes(inputTypes) {
        this.inputTypes = buildArrayOfTypes(inputTypes);
        return this;
    }
    setOutputTypes(outputTypes) {
        this.outputTypes = buildArrayOfTypes(outputTypes);
        return this;
    }
    setRequiredContextTypes(contextTypes) {
        var _a;
        ((_a = this.requestedContextTypesRules) !== null && _a !== void 0 ? _a : (this.requestedContextTypesRules = [])).push({ contextTypes: contextTypes, cardinality: -3 /* Required */ });
        return this;
    }
    setOptionalContextTypes(contextTypes) {
        var _a;
        ((_a = this.requestedContextTypesRules) !== null && _a !== void 0 ? _a : (this.requestedContextTypesRules = [])).push({ contextTypes: contextTypes, cardinality: -1 /* Optional */ });
        return this;
    }
    setLambdaType(factory) {
        this.factory = factory;
        return this;
    }
    setDefinitionOverrideTargetWorkflows(definitionOverrideTargetWorkflows) {
        this.definitionOverrideTargetWorkflows = definitionOverrideTargetWorkflows;
        return this;
    }
    setCorrelatedSignals(signals) {
        if (signals.length !== 0) {
            this.correlatedSignals = signals;
        }
        return this;
    }
    setLambda(lambda, initLambda) {
        this.factory = () => ({
            init: initLambda ? initLambda : (_) => { return Promise.resolve(); },
            execute: lambda,
            dispose: () => { }
        });
        return this;
    }
    validateOptions() {
        return { isValid: true };
    }
}
//# sourceMappingURL=single-item-workflow.js.map